(function () {
  'use strict';

  /* @ngdoc object
   * @name rosterStability
   * @description
   *
   */
  angular
    .module('rosterStability', [
      'ui.router'
    ]);
}());
